import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isValidNumber } from 'libphonenumber-js';

export class PhoneNumberCustomValidator {
    static phoneNumberValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (control.value == null) {
                return null;
            }
            const valid = isValidNumber(control.value);
            return valid ? null : { phoneNumberInvalid: { value: control.value } };
        };
    }
}
